import { Box, Button, Flex, Heading, Icon, Skeleton, Text } from '@chakra-ui/react';
import { HiOutlineTicket } from 'react-icons/hi2';
import { SiGooglemaps } from 'react-icons/si';
import { Button as ButtonScroll } from 'react-scroll';
import { isEmptyObject } from '../../../../../helper/utils/isEmptyObject';
import getStaticAsset from '../../../../../helper/utils/utilsStaticAsset';

export default function HeroSection({ home, outlet }) {
    const isEmpty = isEmptyObject(home);

    return (
        <Box w='full' h='calc(100vh - 100px)' bg='white' my={4} rounded='xl' bgImage={getStaticAsset(home['image'])} bgSize='cover' bgRepeat='no-repeat' bgPosition='center' overflow='hidden'>
            <Box w='full' h='full' bgGradient='linear(to-t, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.1))'>
                <Flex w='full' h='full' flexDirection={{ base: 'column', md: 'row' }} alignItems='end' justifyContent={{ base: 'end', md: 'start' }} p={{ base: 5, md: 8 }}>
                    {isEmpty ? (
                        <Box mb={{ md: 14 }}>
                            <Skeleton w='120px' h='30px' mb={8} />
                            <Skeleton w={{ base: '75vw', md: '50vw' }} mb={2} h='45px' />
                            <Skeleton w={{ base: '50vw', md: '35vw' }} h='45px' />
                            <Skeleton w='125px' h='50px' mt={2} />
                        </Box>
                    ) : (
                        <Box mb={{ md: 14 }} p={0}>
                            <Text color='gray.100' fontSize='14px'>
                                #{home['tag']}
                            </Text>
                            <Heading color='white' fontSize={{ base: '4xl', md: '6xl' }} maxW={{ base: 'full', md: '3xl' }} fontWeight={800}>
                                {home['headline']}
                            </Heading>

                            <Text color='gray.200' fontSize={{ base: '16px', md: '18px' }}>
                                {home['subheadline']}
                            </Text>

                            <Button
                                cursor='pointer'
                                leftIcon={<HiOutlineTicket />}
                                mt={7}
                                px={8}
                                py={7}
                                fontWeight={700}
                                colorScheme='primary'
                                as={ButtonScroll}
                                to='product-overview'
                                smooth
                                delay={200}
                                offset={-200}
                                onClick={() => {
                                    if (typeof home.cta === 'function') {
                                        home.cta();
                                    }
                                }}>
                                {home['ctaTitle']}
                            </Button>

                            {outlet && (
                                <Box mt={7}>
                                    <Flex w='full' alignItems='center' gap={2}>
                                        <Icon as={SiGooglemaps} color='yellow' fontSize='18px' />
                                        <Text color='white' fontWeight={600} lineHeight={1.25} fontSize={{ base: '13px', md: '15px' }}>
                                            {outlet['address'] || ''}
                                        </Text>
                                    </Flex>
                                </Box>
                            )}
                        </Box>
                    )}
                </Flex>
            </Box>
        </Box>
    );
}
